import styled from 'styled-components';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';

export const Wrapper = styled(Flex).withConfig({ displayName: 'AdvertisingProductCard' }).attrs({
    position: 'relative',
    p: 0.5,
    borderRadius: 3,
    background: 'var(--control-tertiary-background)',
})``;

export const LinkOverlay = styled(Box).withConfig({ displayName: 'LinkOverlay' }).attrs({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
})``;
